/* Casa M Spice Co® — lite YouTube facade (DRM-177 PDP CWV).
   Product descriptions embed a raw <iframe src="youtube.com/embed/ID"> inside
   .product_video_section / .video_show. The full YT player is ~1MB + heavy
   main-thread work that lands in the PDP critical path. This swaps each embed
   for a click-to-load poster facade: zero YT bytes until the visitor hits play.
   No content edits — it upgrades whatever YouTube iframes exist in the .rte. */

(function () {
  'use strict';

  function videoId(src) {
    if (!src) return null;
    var m = src.match(/(?:youtube(?:-nocookie)?\.com\/embed\/|youtu\.be\/|[?&]v=)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }

  function buildFacade(iframe) {
    var src = iframe.getAttribute('src') || '';
    var id = videoId(src);
    if (!id) return; // not a YouTube embed — leave it alone

    var label = iframe.getAttribute('title') || 'Play product video';

    var facade = document.createElement('button');
    facade.type = 'button';
    facade.className = 'casam-lyt';
    facade.setAttribute('aria-label', label);
    facade.dataset.id = id;
    // hqdefault is always present; loads lazily and is ~15KB vs ~1MB for the player
    facade.style.backgroundImage =
      "url('https://i.ytimg.com/vi/" + id + "/hqdefault.jpg')";
    facade.innerHTML =
      '<span class="casam-lyt__btn" aria-hidden="true">' +
      '<svg viewBox="0 0 68 48" focusable="false"><path class="casam-lyt__bg" d="M66.5 7.7a8 8 0 0 0-5.6-5.7C56 .7 34 .7 34 .7s-22 0-26.9 1.3A8 8 0 0 0 1.5 7.7 83 83 0 0 0 .2 24a83 83 0 0 0 1.3 16.3 8 8 0 0 0 5.6 5.7C12 47.3 34 47.3 34 47.3s22 0 26.9-1.3a8 8 0 0 0 5.6-5.7A83 83 0 0 0 67.8 24a83 83 0 0 0-1.3-16.3z"/><path d="M45 24 27 14v20z" fill="#fff"/></svg>' +
      '</span>';

    facade.addEventListener('click', function () {
      var real = document.createElement('iframe');
      real.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0');
      real.setAttribute('title', label);
      real.setAttribute('frameborder', '0');
      real.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      real.setAttribute('allowfullscreen', '');
      real.className = 'casam-lyt__frame';
      facade.replaceWith(real);
    });

    iframe.replaceWith(facade);
  }

  function scan(root) {
    (root || document)
      .querySelectorAll('.rte iframe[src*="youtube"], .product_video_section iframe[src*="youtube"], .video_show iframe[src*="youtube"]')
      .forEach(function (f) {
        if (f.dataset.lytDone) return;
        f.dataset.lytDone = '1';
        buildFacade(f);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
})();
